import { faFacebookF } from '@fortawesome/free-brands-svg-icons';

export const socialMediaLinks = () => {
    return [
        { href: 'https://www.facebook.com/Lamalleanimationssenior/', icon: faFacebookF, aria: "Lien facebook"},
    ]
};